import { transport } from 'config/transport';

export function callApiSaveDuChiCongDoan(congDoanId, body, academicYear) {
    return transport.post(`/congdoan/${congDoanId}/duchi`, body, { params: { academicYear } });
}
